import { createAction, createSlice } from "@reduxjs/toolkit";

export default function getFileManagement() {
    const fileManagementSlice = createSlice({
        name: "fileManagement",
        initialState: {
            type: null,
            totalFile: 0,
            data: []
        },
        reducers: {
            startSyncing: (state, action) => {
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'syncing'
                };
            },
            findAndUpdateSyncing: (state, action) => {
                state.data = state.data.map(({ file, answer, ...rest }) => {
                    if (
                        file.originalname === action.payload.file.originalname &&
                        answer.qNo === action.payload.answer.qNo
                    ) {
                        return action.payload; // replace with new payload
                    }
                    return { file, answer, ...rest, type: 'syncing' }; // keep as is
                });
            },
            resetSyncing: (state) => {
                state.totalFile = 0;
                state.data = [];
                state.type = null
            },
            startReSyncing: (state, action) => {
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'reSyncing'
                };
            },
            findAndUpdateReSyncing: (state, action) => {
                state.data = state.data.map((answer) => {
                    if (answer._id === action.payload.data.answer._id) {
                        return { ...answer, processed: true };
                    }
                    return answer;
                });
            },
            resetReSyncing: (state) => {
                state.totalFile = 0;
                state.data = [];
                state.type = null
            }
        }
    });

    return fileManagementSlice.reducer;
}

export const startSyncing = createAction("fileManagement/startSyncing");
export const findAndUpdateSyncing = createAction("fileManagement/findAndUpdateSyncing");
export const resetSyncing = createAction("fileManagement/resetSyncing");

export const startReSyncing = createAction("fileManagement/startReSyncing");
export const findAndUpdateReSyncing = createAction("fileManagement/findAndUpdateReSyncing");
export const resetReSyncing = createAction("fileManagement/resetReSyncing");